import { render, staticRenderFns } from "./MultiSelector.vue?vue&type=template&id=10770e34&scoped=true&"
import script from "./MultiSelector.vue?vue&type=script&lang=js&"
export * from "./MultiSelector.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelector.vue?vue&type=style&index=0&id=10770e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10770e34",
  null
  
)

export default component.exports